// extracted by mini-css-extract-plugin
module.exports = {"root":"root-3nY2M","additional_class":"additional_class-1QO6f","checked":"checked-2vDd0","disabled":"disabled-2gGxs"};